
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"200","height":"200","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"x":"-30.4%","y":"-600%","width":"160.8%","height":"1300%","filterUnits":"objectBoundingBox","id":"id-90a"}},[_c('feOffset',{attrs:{"dy":"4","in":"SourceAlpha","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"4","in":"shadowOffsetOuter1","result":"shadowBlurOuter1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0.388235294 0 0 0 0 0.517647059 0 0 0 0.1 0","in":"shadowBlurOuter1","result":"shadowMatrixOuter1"}}),_c('feMerge',[_c('feMergeNode',{attrs:{"in":"shadowMatrixOuter1"}}),_c('feMergeNode',{attrs:{"in":"SourceGraphic"}})])])]),_c('g',{attrs:{"filter":"url(#id-90a)","transform":"rotate(-43 115.829 4.207)","fill":"#FFF","stroke":"#006384","fill-rule":"evenodd","stroke-opacity":".04"}},[_c('path',{attrs:{"d":"M-.5-.5h25.615v4.692H-.5zM26.577-.5h25.615v4.692H26.577zM53.654-.5h25.615v4.692H53.654z"}})])])
          )
        }
      }
    